import React from 'react'

import { Link } from "react-router-dom";
import ContactUs from "./ContactUs.js";

import './Heading.scss';

function Heading() {
  return (
    <div>
      <div className="block">
        <h1 className="has-text-weight-bold is-size-1 honey-text-font-family-common honey-text-common honey-heading-title">
          Trapping attacks, staying one step ahead
        </h1>
      </div>
      <div className="block">
        <div className="columns">
          <div className="column">
            <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
  Our network of honeypots traps and records a broad spectrum of attacks. HoneyShare gathers and enriches this data, delivering it effortlessly to you while you focus on protecting against threats. Buy a license now and explore our API!
            </h5>
            <br />
            <ContactUs />
          </div>
          <div className="column has-text-centered">
            <div className="block">
              <Link to="/licenses">
                <button className="button honey-heading-button is-danger">Buy a License</button>
              </Link>
            </div>
            <div className="block">
              <Link to="/api">
                <button className="button honey-heading-button">Discover the API</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Heading;
